<div class="modal">
    <h4>{{ editing ? 'Properties' : 'Create new project' }}</h4>
    <div>
        <div class="mt-24">
            <ng-container>
                <label for="tags_input" class="d-flex body-1 mb-8">Select tags</label>
                <div class="tags-select mb-8" [ngClass]="{'tags-select__open': isTagsDropdownOpen}">
                    <div class="tags-select-input" (click)="toggleTagsDropdown()">
                        <div class="tags-list" *ngIf="selectedTags.length > 0">
                            <div *ngFor="let tag of selectedTags" class="tag">
                                {{tag}} 
                                <a class="material-icons-outlined" (click)="removeTag(tag); $event.stopPropagation()">close</a>
                            </div>
                        </div>
                        <div class="placeholder" *ngIf="selectedTags.length === 0">
                            For example: marketing, travelling
                        </div>
                    </div>
                    <div class="tags-select-menu body-2" *ngIf="isTagsDropdownOpen" (click)="$event.stopPropagation()">
                        <div class="menu-item">
                            <input class="input-no-borders" 
                                   type="text" 
                                   placeholder="Type to add new tag..."
                                   [(ngModel)]="newTagInput"
                                   (keyup.enter)="addNewTag()"
                                   id="tags_input">
                            <a class="d-flex-inline align-items-center" (click)="addNewTag()" *ngIf="newTagInput">
                                <span class="material-icons-outlined mr-8">add</span> Add
                            </a>
                        </div>
                        <div class="menu-item menu-item-hover" *ngFor="let tag of allTags">
                            <div>
                                <label class="custom-checkbox custom-checkbox-small" [ngClass]="{'is-check': isTagSelected(tag.name)}">
                                    <input type="checkbox" 
                                           [id]="'tag_' + tag.name" 
                                           [checked]="isTagSelected(tag.name)"
                                           (change)="toggleTag(tag.name)" />
                                    <span></span>
                                </label>
                                <label [for]="'tag_' + tag.name">{{tag.name}}</label>
                            </div>
                            <div class="hover-block">
                                <span>Used by {{tag.usedIn}} projects</span>
                                <a (click)="deleteTag(tag.name)">
                                    <span class="material-icons-outlined">delete</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
        <div class="mt-24">
            <label for="file" class="d-flex body-1 mb-8">Upload file</label>
            <div class="load-data load-data__active" (dragover)="onDragOver($event)" (drop)="onDrop($event)">
            <div class="mb-24">
                <span class="material-icons">upload_file</span>
            </div>
                <div class="body-1 mb-8 text-900" i18n="select xlsx@@upload-file.selectXlsx">
                    Click to upload <label for="file">Local File</label> or <label (click)="pickAndDownloadFile()" for="file">Google Drive</label> or drag and drop
                </div>
                <div class="body-2">
                    DWP, XLS
                </div>

                <input type="file" accept=".xlsx, .dwp" (change)="handleFileInput($event.target.files)" id="file" name="file" enctype="multipart/form-data">
            </div>
            <div *ngIf="false" class="load-data load-data__disabled">
                <div class="mb-24">
                    <span class="material-icons">upload_file</span>
                </div>
                <div class="body-1 mb-8 text-900" i18n="select xlsx@@upload-file.selectXlsx">
                    Click to upload <label>Local File</label> or <label>Google Drive</label> or drag and drop
                </div>
                <div class="body-2">
                    DWP, XLS
                </div>
            </div>
            <div class="mt-24">
                <label for="input_rename" class="d-flex body-1 mb-8">Confirm name</label>
                <div class="input-block mb-8">
                    <input [(ngModel)]="projectName" class="text-field" id="input_rename" type="text" [disabled]="!editing && !fileToUpload && !filename" tabindex="-1">
                </div>
            </div>
            <div *ngIf="fileToUpload" class="load-data-file-info mb-16">
                <div class="d-flex align-items-center justify-content-between mb-8">
                    <div class="d-flex align-items-center">
                        <div>
                            <img [src]="xlsIcon" alt="File XLS">
                        </div>
                        <div class="d-flex flex-column">
                            <span class="body-1 text-900">{{filename}}</span>
                            <span class="body-2">{{fileSizeKB}} KB {{uploadStatus == UploadStatus.InProgress ? ' - loading' : ''}}</span>
                        </div>
                    </div>
                    <div *ngIf="editing && fileToUpload">
                        <button (click)="uploadFile()" [ngClass]="{'loading-small': loading}" class="btn btn-primary">Re-upload</button>
                    </div>
                </div>
                <div [ngClass]="{'bar-error': uploadStatus == UploadStatus.Error, 'bar-warning': uploadStatus == UploadStatus.Warn}" class="bar">
                    <div class="bar-line" [style.width]="uploadPerc + '%'"></div>
                </div>
            </div>
            <div *ngIf="uploadStatus == UploadStatus.Error" class="alert alert-error">
                <div class="wrap-icon">
                    <span class="material-icons-outlined">error</span>
                </div>
                <div class="wrap-text">
                    <p>Import failed. Please check the file and try again.</p>
                </div>
            </div>
            <ng-container *ngIf="blockingIssues">
                <div *ngFor="let issue of blockingIssues" class="alert alert-error">
                    <div class="wrap-icon">
                        <span class="material-icons-outlined">error</span>
                    </div>
                    <div class="wrap-text">
                        <p>{{issue.shortDesc}}</p>
                        <p>{{issue.longDesc}}</p>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="standaloneWarnings">
                <div *ngFor="let warn of standaloneWarnings" class="alert alert-warning">
                    <div class="wrap-icon">
                        <span class="material-icons-outlined">warning_amber</span>
                    </div>
                    <div class="wrap-text">
                        <p>{{warn.shortDesc}}</p>
                        <p>{{warn.longDesc}}</p>
                    </div>
                </div>
            </ng-container>
            <div class="table-container column-border table-big small-cell mt-24" #tableContainer>
                <!-- Header row -->
                <div class="row header">
                    <div *ngFor="let columnName of columnNames; let i = index" class="cell">
                        <div [title]="columnName" class="subtitle-2">{{ columnName }}</div>
                        <span class="body-2">{{ columnUniqueValsCounts[i] }} values</span>
                    </div>
                </div>

                <!-- Data rows -->
                <div class="row">
                    <ng-container *ngFor="let warns of columnWarnings">
                        <td *ngIf="!warns || !warns.length" class="cell"></td>
                        <td *ngIf="warns && warns.length" class="cell cell-warning">
                            <span *ngFor="let warn of warns">
                                <span title="{{warn.longDesc}}">{{warn.shortDesc}}</span><br>
                            </span>
                        </td>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
    <div class="mt-24 d-flex">
        <button *ngIf="editing" (click)="updateProjectMeta()" class="btn btn-primary mr-8" [disabled]="!projectName">Update</button>
        <button (click)="goToWizard()" class="btn btn-primary" [disabled]="!btnGoToWizardEnabled">Go to Import Wizard</button>
    </div>
    <a mat-dialog-close class="btn-close material-icons-outlined">close</a>
</div>
